"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _lastMileDeliveryWellcome = require("@/mixins/last-mile-delivery-wellcome/last-mile-delivery-wellcome");

var _translation = require("@/mixins/translation/translation");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDOrderDateRangeComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderDateRangeComponent, _Mixins);

  var _super = _createSuper(LMDOrderDateRangeComponent);

  function LMDOrderDateRangeComponent() {
    (0, _classCallCheck2.default)(this, LMDOrderDateRangeComponent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(LMDOrderDateRangeComponent, [{
    key: "onDateRangeChanges",
    value: function () {
      var _onDateRangeChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var p;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isAutoAssign) {
                  _context.next = 9;
                  break;
                }

                p = _objectSpread({}, this.$defaultPagination);
                p.pageSize = this.$pagination['pageSize'];
                this.$setPagination(p);
                this.$setSelectedOrders([]);
                _context.next = 7;
                return this.$getUnassignedOrders();

              case 7:
                _context.next = 10;
                break;

              case 9:
                this.$resetPlan();

              case 10:
                this.$selectedLocation = null;
                this.$locationType = this.$defaultLocationType;
                this.$getOrderLocationLists({
                  locationType: this.$defaultLocationType,
                  startTime: this.$startDate,
                  endTime: this.$endDate
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onDateRangeChanges() {
        return _onDateRangeChanges.apply(this, arguments);
      }

      return onDateRangeChanges;
    }()
  }]);
  return LMDOrderDateRangeComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDeliveryWellcome.LastMileDeliveryMixin, _translation.TranslationMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDOrderDateRangeComponent.prototype, "isAutoAssign", void 0);
LMDOrderDateRangeComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderDateRangeComponent',
  components: {
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip
  }
})], LMDOrderDateRangeComponent);
var _default = LMDOrderDateRangeComponent;
exports.default = _default;